import { create } from 'zustand';

import { ICTA } from '@src/types/cta.types';

interface ICtaStore {
  ctas: ICTA[];
  setCtas: (ctas: ICTA[]) => void;
  selectedCta: ICTA | null;

  addCta: (cta: ICTA) => void;
  updateCta: (id: string, updates: Partial<ICTA>) => void;
  deleteCta: (id: string) => void;

  setSelectedCta: (cta: ICTA | null) => void;

  isCtaManagementModalOpen: boolean;
  setIsCtaManagementModalOpen: (isOpen: boolean) => void;

  isCreateCtaModalOpen: boolean;
  setIsCreateCtaModalOpen: (isOpen: boolean) => void;
}

export const useCtaStore = create<ICtaStore>((set) => ({
  ctas: [],
  setCtas: (ctas) => set({ ctas }),

  selectedCta: null,

  addCta: (cta) => set((state) => ({ ctas: [...state.ctas, cta] })),

  updateCta: (id, updates) =>
    set((state) => {
      let updatedCta: ICTA | null = null;

      const ctas = state.ctas.map((c) => {
        if (c._id !== id) return c;
        updatedCta = { ...c, ...updates };
        return updatedCta;
      });

      return {
        ctas,
        selectedCta: state.selectedCta?._id === id ? updatedCta : state.selectedCta,
      };
    }),

  deleteCta: (id) =>
    set((state) => ({
      ctas: state.ctas.filter((c) => c._id !== id),
      selectedCta: state.selectedCta?._id === id ? null : state.selectedCta,
    })),

  setSelectedCta: (selectedCta) => set({ selectedCta }),

  isCtaManagementModalOpen: false,
  setIsCtaManagementModalOpen: (isCtaManagementModalOpen) => set({ isCtaManagementModalOpen }),

  isCreateCtaModalOpen: false,
  setIsCreateCtaModalOpen: (isCreateCtaModalOpen) => set({ isCreateCtaModalOpen }),
}));
